export default "__VITE_ASSET__B3GAz22h__"